import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type ClientGroupItem = Omit<ClientGroupInternalItem, 'version'>;

type ClientGroupInternalItem = {
    readonly version: string;
    readonly externalId: string;
    readonly isDefault: boolean;
    readonly name: string;
};

export class ClientGroupCollectionQuery extends Query<ClientGroupItem[]> { }

export class ClientGroupCollectionQueryHandlerBase implements QueryHandler<ClientGroupCollectionQuery, ClientGroupItem[]> {
    public static Url = TaggedUrl.join('clients/groups', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: ClientGroupCollectionQuery): Promise<ClientGroupItem[]> {
        const { data } = await this.http.get<ClientGroupInternalItem[]>(ClientGroupCollectionQueryHandlerBase.Url, {
            params: {
                isDeleted: false
            }
        });
        return data.map(i => ({
            externalId: i.externalId,
            isDefault: i.isDefault,
            name: i.name
        }));
    }
}
